import { render, staticRenderFns } from "./step-cost-description.vue?vue&type=template&id=46764264"
import script from "./step-cost-description.vue?vue&type=script&lang=ts"
export * from "./step-cost-description.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports